const text = (value) => (value === null || value === undefined ? '' : String(value).trim());

const firstText = (values = []) => values.map(text).find(Boolean) || '';

const evidenceIdentifier = (record = {}, draftPreview = null) => firstText([
  record.manualOrderItemId,
  record.manualReferenceId,
  record.orderItemId,
  record.__orderItemId,
  record.referenceId,
  record.referenceID,
  record.sourceRowKey,
  record.targetRowKey,
  record.accountMatch?.orderItemId,
  record.accountMatch?.referenceId,
  record.sourceEvidence?.id,
  record.sourceEvidence?.rowKey,
  record.targetEvidence?.id,
  record.targetEvidence?.rowKey,
  draftPreview?.evidenceAction?.manualOrderItemId,
  draftPreview?.evidenceAction?.manualReferenceId,
  draftPreview?.action?.manualOrderItemId,
  draftPreview?.action?.manualReferenceId,
]);

const salesforceAccountIdentifier = (record = {}, draftPreview = null) => firstText([
  record.salesforceAccountId,
  record.accountId,
  record.accountMatch?.salesforceAccountId,
  draftPreview?.evidenceAction?.salesforceAccountId,
  draftPreview?.action?.salesforceAccountId,
]);

export const hasEvidenceLink = (record = {}, draftPreview = null) => Boolean(evidenceIdentifier(record, draftPreview));
export const hasSalesforceAccount = (record = {}, draftPreview = null) => Boolean(salesforceAccountIdentifier(record, draftPreview));

export const bindingQuality = (record = {}, draftPreview = null) => {
  const hasDraftPreview = Boolean(draftPreview);
  const missingEvidenceLink = !hasDraftPreview && typeof record.missingEvidenceLink === 'boolean'
    ? record.missingEvidenceLink
    : !hasEvidenceLink(record, draftPreview);
  const missingSalesforceAccount = !hasDraftPreview && typeof record.missingSalesforceAccount === 'boolean'
    ? record.missingSalesforceAccount
    : !hasSalesforceAccount(record, draftPreview);
  return {
    missingEvidenceLink,
    missingSalesforceAccount,
    status: missingEvidenceLink && missingSalesforceAccount
      ? 'both'
      : missingEvidenceLink
      ? 'missing_evidence'
      : missingSalesforceAccount
      ? 'missing_account'
      : 'linked',
  };
};

export const accountConfidenceLabel = (method = '', confidence = '') => {
  const normalized = text(method).toLowerCase();
  const score = Number(confidence);
  if (normalized.includes('manual')) return 'manual';
  if (normalized.includes('suggest')) return 'suggested';
  if (normalized.includes('exact') || score >= 95) return 'exact';
  if (normalized.includes('product') || score >= 80) return 'product-code inferred';
  if (normalized.includes('brand') || score >= 60) return 'brand inferred';
  return 'unresolved';
};

export const compactBindingLabel = (record = {}, draftPreview = null) => firstText([
  evidenceIdentifier(record, draftPreview),
  salesforceAccountIdentifier(record, draftPreview),
  record.salesforceAccountName,
]) || '--';

export { evidenceIdentifier, salesforceAccountIdentifier, text };
